import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ReactGA from 'react-ga'
import { connect } from 'react-redux'

import { logIn as SlogIn, addChallenge as SaddChallenge } from '../../../store/actions/Session'

import { Form, LoginStyle } from './../../../styles'
import { Field, Button, User, Error } from './../../../components'

class Login extends Component {
  state = {
    waiting: false,
    error: '',
    form: {},
  }

  componentDidMount() {
    ReactGA.pageview('/login');
  }

  componentWillReceiveProps ({ fields, error }) {
    if (fields !== this.props.fields) {
      fields.map(({ name, value }) => {
        if (value && this.state[name] !== value) {
          this.setState({ [name]: value })
        }
        return value
      })
    }
  }

  requestLogin = async () => {
    await this.props.logIn(this.state.form).then(() => {
      if (this.props.error && this.props.error !== '') this.setState({error: this.props.error})
    }).catch((err) => {
      console.log('Someting Wrong with Login.', err)
    })
  }

  addFormData = (data) => {
    const { form } = this.state
    const row = []
    row[data.key] = data.value
    this.setState({ form: { ...form, ...row} })
  }

  render() {
    const { fields } = this.props
    const { error } = this.state
    return (
      <div className={ `login ${LoginStyle}`}>
        <form className={Form} onSubmit={this.requestLogin}>
          {fields.map((field) => (
            <Field onChange={this.addFormData} {...field} key={field.id}> {field.placeholder} </Field>
          ))}
          <Button type="submit" onCallback={this.requestLogin}> <User width="24" height="24" /> Log In </Button>
          {
             error !== '' && (
              <Error>{error}</Error>
            )
          }
        </form>
        <div className="login--bottom">
          <Link to="/forgot-password"> Forgot my password </Link>
        </div>
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    fields: Session.fields,
    error: Session.error && Session.error.message
  }),
  dispatch => ({
    logIn: fields => dispatch(SlogIn(fields))
  })
)(Login)


// WEBPACK FOOTER //
// ./src/scenes/Auth/Pages/Login.js